import { atom, useRecoilState } from 'recoil'

import type { NotificationMessage } from '../types/notificiation-types'

const notificationCenterAtom = atom({
  key: 'notificationCenter',
  default: {
    unreadNotifications: 0,
    notifications: [] as NotificationMessage[],
    isLoading: true,
  },
})

function useNotificationCenterState() {
  const [notificationCenterState, setNotificationCenterState] = useRecoilState(notificationCenterAtom)

  return {
    setNotificationCenterState,
    notificationCenterState,
  }
}

export { useNotificationCenterState }
